export const CLI_KIT_VERSION = '3.47.3'
